import { Documentzero_table_interface } from '@bludata/common-interfaces';

export const defaultFormValues: Documentzero_table_interface = {
  numero: '',
  data: '',
  filiale: '',
  tipoB2b: '',
  titolo: '',
  cognome: '',
  nome: '',
  indirizzo: '',
  citta: '',
  cap: '',
  prov: '',
  stato: '',
  codfiva: '',
  partitaIva: '',
  codiceDestinatarioB2b: '',
  pecDocumenti: '',
  pagamento: '',
  riferimento: '',
  bancaAppoggio: '',
  annotazioni: '',
  scadenzerate: '',
  speseTrasporto: null,
  codiceIvaSpeseTrasporto: '',
  ivaSpeseTrasporto: null,
  speseImballo: null,
  codiceIvaSpeseImballo: '',
  ivaSpeseImballo: null,
  speseRivalsa: null,
  codiceIvaSpeseRivalsa: '',
  ivaSpeseRivalsa: null,
  speseBolli: null,
  codiceIvaSpeseBolli: '',
  ivaSpeseBolli: null,
  arrotondamento: null,
  codiceIvaArrotondamento: '',
  ivaArrotondamento: null,
  id: null,
  siglaDocumento: '',
  codiceFiliale: '',
  operatore: '',
  dataReg: '',
  dispositivo: '',
  scontrinoFiscale: '',
  dataScontrino: '',
  scontrinoFiscale2: '',
  dataScontrino2: '',
  ragioneSociale: '',
  codiceControparte: '',
  codiceCausale: '',
  causale: '',
  porto: '',
  dataInizio: '',
  oraInizio: '',
  peso: '',
  colli: '',
  aspetto: '',
  mezzo: '',
  destinazione: '',
  destinazioneIndirizzo: '',
  destinazioneCitta: '',
  destinazioneCap: '',
  destinazioneProvincia: '',
  codiceVettore: '',
  vettore: '',
  vettoreIndirizzo: '',
  note: '',
  testoAggiuntivo: '',
  imponibileIva1: null,
  imponibileIva2: null,
  imponibileIva3: null,
  imponibileIva4: null,
  imponibileIva5: null,
  imponibileIva6: null,
  iva1: null,
  iva2: null,
  iva3: null,
  iva4: null,
  iva5: null,
  iva6: null,
  codiceIva1: '',
  codiceIva2: '',
  codiceIva3: '',
  codiceIva4: '',
  codiceIva5: '',
  codiceIva6: '',
  importoIva1: null,
  importoIva2: null,
  importoIva3: null,
  importoIva4: null,
  importoIva5: null,
  importoIva6: null,
  esigibilitaIva1: '',
  esigibilitaIva2: '',
  esigibilitaIva3: '',
  esigibilitaIva4: '',
  esigibilitaIva5: '',
  esigibilitaIva6: '',
  totale: null,
  matricola: '',
  euro: null,
  campo1_d: '',
  spese: null,
  ivaSpese: null,
  codiceIvaSpese: '',
  bloccaPagamenti: null,
  codicePagamento: '',
  tipoControparte: '',
  controllato: null,
  statoContabile: '',
  fatturato: null,
  codiceAzienda: '',
  ragioneSocialeAz: '',
  indirizzoAz: '',
  cittaAz: '',
  capAz: '',
  provAz: '',
  codfivaAz: '',
  partitaIvaAz: '',
  infoagg1Az: '',
  infoagg2Az: '',
  regminsanitaAz: '',
  ragioneSocialeNe: '',
  indirizzoNe: '',
  cittaNe: '',
  capNe: '',
  provNe: '',
  codfivaNe: '',
  partitaIvaNe: '',
  infoagg1Ne: '',
  infoagg2Ne: '',
  regminsanitaNe: '',
  filialeRicavo: '',
  filialeCosto: '',
  codiceMagazzino: '',
  campo2_d: '',
  campo3_d: '',
  stampato: null,
  annullato: false,
  tipoOperazione: '',
  destinazioneStato: '',
  totalequantita: null,
  codiceDistributore: '',
  bancaaziendanome: '',
  bancaaziendafiliale: '',
  bancaaziendaiban: '',
  codiceTransazione: '',
  codiceTransazioneReso: '',
  opposizioneSts: false,
  numeroDocumentoReso: '',
  dataDocumentoReso: '',
  dispositivoDocumentoReso: '',
  statoSts: '',
  siglaDocumentoMaster: '',
  codiceDocumentoMaster: '',
  statoSts2: '',
  partitaIvaSts: '',
  indirizzo1b: '',
  statoB2b: '',
  elettronica: null,
  erroreB2b: '',
  art73: null,
  rea_ufficio: '',
  rea_numerorea: '',
  rea_capsoc: '',
  rea_sociounico: '',
  rea_statoliquid: '',
  rf_idpaese: '',
  rf_idcodice: '',
  rf_codfisc: '',
  rf_denominazione: '',
  rf_nome: '',
  rf_cognome: '',
  so_indirizzo: '',
  so_cap: '',
  so_comune: '',
  so_provincia: '',
  so_nazione: '',
  ti_idpaese: '',
  ti_idcodice: '',
  ti_codfisc: '',
  ti_denominazione: '',
  ti_nome: '',
  ti_cognome: '',
  rf_idpaeseAz: '',
  rf_idcodiceAz: '',
  rf_codfiscAz: '',
  rf_denominazioneAz: '',
  rf_nomeAz: '',
  rf_cognomeAz: '',
  so_indirizzoAz: '',
  so_capAz: '',
  so_comuneAz: '',
  so_provinciaAz: '',
  so_nazioneAz: '',
  nazioneAz: '',
  regimefiscale: '',
  formatotrasmissione: '',
  dataB2b: '',
  tipoImpresa: '',
  dataOperazione: '',
  nomeAz: '',
  cognomeAz: '',
  tipoImpresaAz: '',
  resaIndirizzo: '',
  resaCap: '',
  resaCitta: '',
  resaProv: '',
  resaNazione: '',
  codiceEori: '',
  codiceEoriAz: '',
  soggettoEmittente: '',
  eMail: '',
  rf_eori: '',
  ti_eori: '',
  telefonoAz: '',
  faxAz: '',
  eMailAz: '',
  telefonoNe: '',
  faxNe: '',
  eMailNe: '',
  idPortale: '',
  portale: '',
  tipoRitenuta: '',
  importoRitenuta: null,
  aliquotaRitenuta: null,
  causaleRitenuta: '',
  percentualeImponibileRitenuta: null,
  tipoCassa1: '',
  aliquotaCassa1: null,
  importoCassa1: null,
  imponibileCassa1: null,
  ivaCassa1: null,
  codiceIvaCassa1: '',
  percentualeImponibileCassa1: null,
  ritenutaCassa1: null,
  riferimentoCassa1: '',
  tipoCassa2: '',
  aliquotaCassa2: null,
  importoCassa2: null,
  imponibileCassa2: null,
  ivaCassa2: null,
  codiceIvaCassa2: '',
  percentualeImponibileCassa2: null,
  ritenutaCassa2: null,
  riferimentoCassa2: '',
  cassaPrevidenziale: null,
  ritenuta: null,
  subtotale: null,
  causaleFe: '',
};
